'use strict';

exports.__esModule = true;

var _Redirect = require('react-router/Redirect');

var _Redirect2 = _interopRequireDefault(_Redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/Redirect.js
 ** module id = 84
 ** module chunks = 0
 **/